import resumeImg from './ResumeImg.jpg'
import resume from './Resume.pdf'
import './styles/Portfolio.css'

export default function Resume({setPortfolioPage}) {

    return (
        <div className='resume-container'>
            <section className='resume-controls'>
                <button onClick={() => {setPortfolioPage('Portfolio')}} className='resume-download'>X</button>
                <button className='resume-download'>
                    <a href={resume} download={resume}>Download</a>
                </button>
            </section>
                
                <img src={resumeImg} alt='resume' className='resume'></img>
        </div>
    )
}